import Controller from '../utilities/layout-editor-base-controller';
import Client from '../utilities/layouts/client';
import Renderer from '../utilities/layouts/renderer';
import EventPublisher from '../utilities/event_publisher';

/* Read-only layout canvas. Left click on a position finds its row; right click on a
   booked one offers a Move per guest; while a move form is open the canvas is the picker. */
export default class extends Controller {
  static targets = ['menu']

  async connect() {
    const canvasSize = { height: 50, width: 1200 }
    window.addEventListener('position-selected', this.positionSelected);
    window.addEventListener('booking-move:targets', this.enterMoveMode);
    window.addEventListener('booking-move:choice', this.showMoveChoice);
    window.addEventListener('booking-move:end', this.leaveMoveMode);
    document.addEventListener('click', this.hideMenu, true);
    document.addEventListener('keydown', this.hideMenuOnEscape);
    window.addEventListener('scroll', this.hideMenu, true);
    await this.loadLayout(Client, Renderer, true, canvasSize);
    this.renderer.canvas.on('contextmenu', this.contextMenu);
  }

  disconnect() {
    window.removeEventListener('position-selected', this.positionSelected);
    window.removeEventListener('booking-move:targets', this.enterMoveMode);
    window.removeEventListener('booking-move:choice', this.showMoveChoice);
    window.removeEventListener('booking-move:end', this.leaveMoveMode);
    document.removeEventListener('click', this.hideMenu, true);
    document.removeEventListener('keydown', this.hideMenuOnEscape);
    window.removeEventListener('scroll', this.hideMenu, true);
    this.renderer?.canvas.off('contextmenu', this.contextMenu);
  }

  positionSelected = event => {
    const { position } = event.detail;
    if (this.renderer?.moveTargets) {
      this.pickMoveTarget(position);
      return;
    }

    const row = document.getElementById(position.identifier);
    if (!row) return;

    row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    row.classList.add('highlighted');
    setTimeout(() => row.classList.remove('highlighted'), 4000);
  }

  pickMoveTarget(position) {
    if (this.renderer.isMoveTarget(position)) {
      EventPublisher.publish('booking-move:pick', { inventoryUnitId: position.inventoryUnitId, identifier: position.identifier });
    }
    this.renderer.canvas.discardActiveObject();
    this.renderer.canvas.requestRenderAll();
  }

  // Fabric has already hit-tested; the row's Move buttons are the source of truth and
  // the menu just relabels and clicks them
  contextMenu = ({ e, target }) => {
    if (this.renderer.moveTargets) return;

    const position = target && this.renderer.positionFor(target);
    const row = position && document.getElementById(position.identifier);
    const triggers = row ? [...row.querySelectorAll('[data-side-panel-url]')] : [];
    if (triggers.length === 0) return;

    e.preventDefault();
    this.showMenu(e, triggers);
  }

  showMenu(event, triggers) {
    const items = triggers.map(trigger => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'beachy-dropdown-item';
      item.setAttribute('role', 'menuitem');
      const { guest, time } = trigger.dataset;
      item.textContent = time ? `Move ${guest} · ${time}` : `Move ${guest}`;
      item.addEventListener('click', () => trigger.click());
      return item;
    });
    this.menuTarget.replaceChildren(...items);
    this.menuTarget.style.left = `${event.clientX}px`;
    this.menuTarget.style.top = `${event.clientY}px`;
    this.menuTarget.hidden = false;
    this.menuTarget.classList.add('beachy-dropdown-open');
    items[0].focus();
  }

  hideMenu = () => {
    if (!this.hasMenuTarget || this.menuTarget.hidden) return;

    this.menuTarget.hidden = true;
    this.menuTarget.classList.remove('beachy-dropdown-open');
  }

  hideMenuOnEscape = event => {
    if (event.key === 'Escape') this.hideMenu();
  }

  enterMoveMode = event => {
    const { unitIds, fromUnitId, chosenUnitId } = event.detail;
    this.renderer?.setMoveTargets(unitIds, fromUnitId, chosenUnitId);
  }

  showMoveChoice = event => {
    this.renderer?.setMoveChoice(event.detail.inventoryUnitId);
  }

  leaveMoveMode = () => {
    this.renderer?.clearMoveTargets();
  }
}
